import React from 'react';
import { Input, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import ConfirmButton from '../Modal/ConfirmButton';
// import ReactMoneyComponent from 'react-currency-input-mask'

class FormEntries extends React.Component {

    componentDidMount = () => {
        this.props.log('FormEntries.js/componentDidMount');
    }

    render() {
        this.props.info('FormEntries.js/render');
        const combinedData = this.props.formEntries.map(entry => {
            let obj = entry;
            obj.data = { ...this.props.data, ...obj.data }
            return obj;
        })
        return (
            <Table className="table-sm">
                <thead>
                    {!this.props.config.limit && this.props.isCriteriaMet() && combinedData.length > 0 ? <tr className="font-weight-bold adminRow">
                        {this.props.config.rowFields != null ?
                            <>
                                {this.props.config.rowFields.map(field => (
                                    <th className={"headerSelect align-top px-2 "+field.classNames} key={field.uniqueId} onClick={() => this.props.setSort(field.uniqueId, field.type)}>
                                        <div>{field.field}
                                            {field.uniqueId === this.props.sort ? <span className="sortChevron">
                                                <FontAwesomeIcon icon={this.props.sortAsc ? faChevronUp : faChevronDown} />
                                            </span> : null}
                                        </div>
                                    </th>
                                ))}
                            </>
                            : <th className="align-top">Entry ID</th>
                        }
                        {this.props.config.showDateCreated ? <th className={"headerSelect text-center align-top"} onClick={() => this.props.setSort('dateCreated', 'date')}>Date Created
                            {this.props.sort === 'dateCreated' ? <span className="sortChevron">
                                <FontAwesomeIcon icon={this.props.sortAsc ? faChevronUp : faChevronDown} />
                            </span> : null}
                        </th> : null}
                        {this.props.config.showUserCreated ? <th className={"headerSelect text-center align-top"} onClick={() => this.props.setSort('userCreated', 'date')}>Created By
                            {this.props.sort === 'userCreated' ? <span className="sortChevron">
                                <FontAwesomeIcon icon={this.props.sortAsc ? faChevronUp : faChevronDown} />
                            </span> : null}
                        </th> : null}
                        {this.props.config.showDateUpdated ? <th className={"headerSelect text-center align-top"} onClick={() => this.props.setSort('dateUpdated', 'date')}>Date Updated
                            {this.props.sort === 'dateUpdated' ? <span className="sortChevron">
                                <FontAwesomeIcon icon={this.props.sortAsc ? faChevronUp : faChevronDown} />
                            </span> : null}
                        </th> : null}
                        {this.props.config.showUserUpdated ? <th className={"headerSelect text-center align-top"} onClick={() => this.props.setSort('userUpdated', 'date')}>Updated By
                            {this.props.sort === 'userUpdated' ? <span className="sortChevron">
                                <FontAwesomeIcon icon={this.props.sortAsc ? faChevronUp : faChevronDown} />
                            </span> : null}
                        </th> : null}
                        <th></th>
                    </tr> : null}

                    {!this.props.config.limit && this.props.isCriteriaMet() && combinedData.length > 0 ? <tr className="font-weight-bold adminRow">
                        {this.props.config.rowFields != null ?
                            <>
                                {this.props.config.rowFields.map(field => (
                                    <th className="headerSelect align-top px-1" key={field.uniqueId} onClick={() => this.props.setSort(field.uniqueId, field.type)}>
                                        {combinedData.length > 1 ? <div>
                                            <Input
                                                type="text"
                                                name={field.uniqueId}
                                                placeholder={"Filter " + field.field}
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={this.props.onChangeFilter}
                                                value={this.props.isFieldNull(this.props.filter[field.uniqueId])}
                                            />
                                        </div> : null}</th>
                                ))}
                            </>
                            : <th className="align-top">Entry ID</th>
                        }
                        {this.props.config.showDateCreated ? <th></th> : null}
                        {this.props.config.showUserCreated ? <th></th> : null}
                        {this.props.config.showDateUpdated ? <th></th> : null}
                        {this.props.config.showUserUpdated ? <th></th> : null}
                        <th></th>
                    </tr> : null}
                </thead>
                <tbody>
                    {!this.props.config.limit && this.props.isCriteriaMet() ? this.props.orderEntries(combinedData, { uniqueId: this.props.sort, asc: this.props.sortAsc, type: this.props.sortType }).filter(entry => {
                        let temp = true;
                        Object.keys(this.props.filter).forEach(field => {
                            if ((entry.data[field] != null && this.props.filter[field] != null &&
                                (entry.data[field].toUpperCase().indexOf(this.props.filter[field].toUpperCase()) === -1)) ||
                                ((this.props.filter[field] != null && this.props.filter[field] !== '') && entry.data[field] == null)) temp = false;
                        })
                        return temp;
                    }).map(entry => (
                        <tr key={entry.formEntryId} className={"adminRow pointer" + (this.props.selectedFormEntry === entry.formEntryId ? " activeTab" : "")} onClick={() => this.props.loadData(entry)}>
                            {this.props.config.rowFields != null ?
                                <>
                                    {this.props.config.rowFields.map(field => (
                                        <td className={(field.classNames)+" px-2"} key={field.uniqueId}>{this.props.getFormattedField(entry.data[field.uniqueId], field.type)}</td>
                                    ))}
                                </>
                                : <td>{entry.formEntryId}</td>
                            }
                            {this.props.config.showDateCreated ?
                                <td className={this.props.config.shrinkDbFields ? "dbField" : ''}>{entry.dateCreated != null && entry.dateCreated !== '' ?
                                    this.props.getFormattedDate(new Date(entry.dateCreated)) + ' ' + this.props.formatAMPM(new Date(entry.dateCreated)) : ''}</td>
                                : null}
                            {this.props.config.showUserCreated ?
                                <td className={this.props.config.shrinkDbFields ? "dbField" : ''}>{entry.userCreated != null ?
                                    entry.userCreated[0].firstName + ' ' + entry.userCreated[0].lastName : ''}</td>
                                : null}
                            {this.props.config.showDateUpdated ?
                                <td className={this.props.config.shrinkDbFields ? "dbField" : ''}>{entry.dateUpdated != null && entry.dateUpdated !== '' ?
                                    this.props.getFormattedDate(new Date(entry.dateUpdated)) + ' ' + this.props.formatAMPM(new Date(entry.dateUpdated)) : ''}</td>
                                : null}
                            {this.props.config.showUserUpdated ?
                                <td className={this.props.config.shrinkDbFields ? "dbField" : ''}>{entry.userUpdated != null ?
                                    entry.userUpdated[0].firstName + ' ' + entry.userUpdated[0].lastName : ''}</td>
                                : null}
                            <td className="text-right">
                                <ConfirmButton className="mx-1" color="danger" onClick={() => this.props.deleteEntry(entry.formEntryId)} title="Delete Entry">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>
                            </td>
                        </tr>
                    )) : null}
                    <tr className="mt-5"></tr>
                </tbody>
            </Table>
        );
    }
}

export default FormEntries;